module.exports = __webpack_public_path__ + "img/buildasentence.77141f47.png";